/* eslint-disable no-prototype-builtins */
const isApiSingleSelectionFilter = (item) => {
    return item.hasOwnProperty('selectedOption');
};
const isApiBase = (option) => {
    return option.hasOwnProperty('description') && option.hasOwnProperty('code');
};
const isApiNumberRangeFilter = (item) => {
    return item.hasOwnProperty('min') && item.hasOwnProperty('max');
};

export { isApiNumberRangeFilter as default, isApiBase, isApiSingleSelectionFilter };
//# sourceMappingURL=typeGuards.js.map
